__turbopack_context__.v({
  "disclaimer": "TTvBJa_disclaimer",
  "home-by-the-numbers-container": "TTvBJa_home-by-the-numbers-container",
});
